<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-9">
      <span class="iso-header ml-2">
  {{'bikeshop.menu.message_templates' | translate}}
</span>
    </div>
  </div>
  <div>

    <div style="display: flex;">
      <div class="packages-container">
        <div class="package general-iso-card">
          <div class="package-title text-primary" *ngIf="credits && credits.length>0">
            {{'bikeshop.purchase-messaging-bundle.credits-header' | translate}}</div>
          <div class="credits-container">
            <div *ngFor="let credit of credits">
              <div class="text-secondary">{{credit.CreditsPurchased - credit.CreditsUsed}}</div>
              <div>{{credit.MessageType}}{{credit.CreditsPurchased - credit.CreditsUsed!=1 ? "'s" : ""}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <!-- <div class="packages-header">{{'bikeshop.purchase-messaging-bundle.bundle-header' | translate}}</div> -->
          <div class="packages-container">
            <div *ngIf="packages && packages.length===0 && !loadingBundles" class="package general-iso-card">
              <div class="no-bundles">
                {{'bikeshop.purchase-messaging-bundle.no_bundles_for_country' | translate}}
              </div>
            </div>
            <div class="package general-iso-card" *ngFor="let package of packages" [ngClass]="{'sms': package.typeID===3}">
              <div class="package-title">{{package.packageDescription}}</div>
              <div style="display: flex;">
                <div>
                  <div class="package-type">{{'bikeshop.purchase-messaging-bundle.package-type' | translate}}:
                    {{package.typeID===3 ? 'SMS' : 'Other'}}</div>
                  <div class="package-credits">{{package.credits}}
                    {{'bikeshop.purchase-messaging-bundle.credits' | translate}}</div>
                </div>
                <div class="package-cost"><span>{{package.currencySymbol}}</span><span>{{package.amount}}</span></div>
              </div>
              <div class="margin-top-32">
                <button class="iso-round-button full-width"
                  (click)="buyBundleConfirm(package)">{{'bikeshop.purchase-messaging-bundle.buy_bundle' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <div class="content general-iso-card" style="min-height: 400px;">
          <div class="transaction-type-header">{{'bikeshop.purchase-messaging-bundle.credit_history' | translate}}</div>
          <p-table #table1 [value]="creditTransactionHistory"
            [paginator]="creditTransactionHistory && creditTransactionHistory.length > 5 ? true : false" [rows]="5">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 300px;">{{'bikeshop.purchase-messaging-bundle.transaction' | translate}}</th>
                <th>{{'bikeshop.purchase-messaging-bundle.date' | translate}}</th>
                <th>{{'bikeshop.purchase-messaging-bundle.paid' | translate}}</th>
                <th>{{'bikeshop.purchase-messaging-bundle.credits' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction>
              <tr [pSelectableRow]="transaction">
                <td>{{transaction.Description}}</td>
                <td>{{transaction.Date | date : 'MMM yyyy'}}</td>
                <td>{{transaction.AmountUnit}} {{transaction.Amount}}</td>
                <td>{{transaction.Credits}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div class="col-xl-6">
        <div class="content general-iso-card" style="min-height: 400px;">
          <div class="transaction-type-header">{{'bikeshop.purchase-messaging-bundle.usage_history' | translate}}</div>
          <p-table #table2 [value]="transactionHistory"
            [paginator]="transactionHistory && transactionHistory.length > 5 ? true : false" [rows]="5">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 300px;">{{'bikeshop.purchase-messaging-bundle.transaction' | translate}}</th>
                <th>{{'bikeshop.purchase-messaging-bundle.date' | translate}}</th>
                <th>{{'bikeshop.purchase-messaging-bundle.credits' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction>
              <tr [pSelectableRow]="transaction">
                <td>{{transaction.Description}}</td>
                <td>{{transaction.Date | date : 'MMM yyyy'}}</td>
                <td>{{transaction.Credits}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>


    <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
    <p-confirmDialog></p-confirmDialog>
